import { render, staticRenderFns } from "./StoresMapSection.vue?vue&type=template&id=a2639b24&"
import script from "./StoresMapSection.vue?vue&type=script&lang=js&"
export * from "./StoresMapSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports